// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Core__List = require("@rescript/core/src/Core__List.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var SystemMessage = require("../../uikit/reason/molecules/SystemMessage/SystemMessage.bs.js");
var SystemMessages = require("./SystemMessages.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var ReactTransitionGroup = require("react-transition-group");

function SystemMessageDisplay$SystemMessage(props) {
  var dismiss = props.dismiss;
  var message = props.message;
  return JsxRuntime.jsx(SystemMessage.make, {
              id: message.id,
              time: message.time,
              text: message.text,
              type_: message.type_,
              dismissible: Core__Option.map(dismiss, (function (param) {
                      return true;
                    })),
              handleOnDismiss: dismiss,
              children: Caml_option.some(props.children)
            });
}

var SystemMessage$1 = {
  make: SystemMessageDisplay$SystemMessage
};

function SystemMessageDisplay$Spread(props) {
  return React.cloneElement(props.children, props.props);
}

var Spread = {
  make: SystemMessageDisplay$Spread
};

function SystemMessageDisplay(props) {
  var match = SystemMessages.useSystemMessages();
  var removeMessage = match.removeMessage;
  return JsxRuntime.jsx(SystemMessageDisplay$Spread, {
              props: {
                "aria-live": "polite"
              },
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(ReactTransitionGroup.TransitionGroup, {
                          children: Core__List.toArray(Core__List.map(match.messages, (function (msg) {
                                      var render = msg.renderButtons;
                                      return JsxRuntime.jsx(ReactTransitionGroup.CSSTransition, {
                                                  classNames: {
                                                    enter: "system-message-enter",
                                                    enterActive: "system-message-enter-active",
                                                    exit: "system-message-exit",
                                                    exitActive: "system-message-exit-active"
                                                  },
                                                  timeout: {
                                                    enter: 500,
                                                    exit: 500
                                                  },
                                                  children: JsxRuntime.jsx(SystemMessageDisplay$SystemMessage, {
                                                        message: msg,
                                                        dismiss: msg.dismissable ? removeMessage : undefined,
                                                        children: render !== undefined ? render(msg.id) : null
                                                      }, msg.id)
                                                }, msg.id);
                                    })))
                        }),
                    className: "sticky top-0 z-[200]"
                  })
            });
}

var make = SystemMessageDisplay;

var $$default = SystemMessageDisplay;

exports.SystemMessage = SystemMessage$1;
exports.Spread = Spread;
exports.make = make;
exports.default = $$default;
exports.__esModule = true;
/* react Not a pure module */
